jQuery(function ($) {
  /*----------------------------------
    slickのオプション
  ------------------------------------*/
  const $slides = $(".slides");
  $slides
    .slick({
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 1500,
      arrows: false,
      fade: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    })
    .on({
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("pre-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
      },
      afterChange: function () {
        $(".pre-slide", this).removeClass("pre-slide  slide-animation");
      },
    });
  $slides.find(".slick-slide").eq(0).addClass("slide-animation");
});
